import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isShowingMore", "translations"];
import React from 'react';
export function ShowMoreButton(_ref) {
  var isShowingMore = _ref.isShowingMore,
    translations = _ref.translations,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", props, translations.showMoreButtonText({
    isShowingMore: isShowingMore
  }));
}